module.exports = __webpack_public_path__ + "img/Kathleen.af1e2fc2.png";